import { ITireItemDetail } from "features/car_model/types";
import { MstItemDetailWheel, MstItemDetailWheelSelectResponse } from "./index";

export type TInputCode = "wheel" | "tire";

export enum CombinationType {
  WheelWithTires = "wheelWithTires", // 商品コードの組合せ（ホイール1種類＋タイヤ5種類まで検索）
  TireWithWheels = "tireWithWheels", // 商品コードの組合せ（タイヤ1種類＋ホイール4種類まで検索）
}

export interface ISearchCode {
  wheel: string[];
  tire: string;
}

export interface WheelDetailSearch {
  item_name: string;
  item_cd: string;
  wheel_size: string;
  wheel_rim_diam?: string;
}

export interface TireDetailSearch {
  item_cd: string;
  item_name: string;
  tire_width: number;
  tire_size: string;
  tire_aspect_ratio: number | null;
  tire_rim_diam: string | null;
  tire_category: string | null;
  tire_loin_speed_mark: string | null;
}

export interface IProductSearchEntry {
  wheels: MstItemDetailWheel[] | [];
  tires: ITireItemDetail[] | [];
}

export interface IWheelRawData {
  data: MstItemDetailWheelSelectResponse;
  status: 200;
}

export interface ISearchResult {
  productCode: string;
  productName: string;
  size: string;
  loadIndex: string;
  rimDiam?: string | null;
  mismatch?: boolean;
  combineType?: CombinationType;
}
